module.exports = __webpack_public_path__ + "img/arrow_upward.245206ef.svg";